import Vue from 'vue';
import i18n from "../../../i18n";

export default {


  async fetchVesselActivities({ commit }, { mainId }) {
    Vue.$log.debug('loading dpr activity for', mainId);
    return Vue.axios.get(Vue.$url("vessel-activity?dprMainId=" + mainId))
      .then((rsp) => commit("SET_VESSEL_ACTIVITIES", rsp.data));

  },

  async createVesselActivity({ commit }, payload) {
    let silentUpdate = payload.silentUpdate;
    delete payload.silentUpdate;

    return Vue.axios
      .post(Vue.$url("vessel-activity"), payload)
      .then((rsp) => {
        if (!silentUpdate) {
          commit('mShowInfoMessage', 'Vessel Activity saved', { root: true });
        }
        return rsp.data;
      })
  },

  async cloneVesselActivity({ commit }, payload) {
    let silentUpdate = payload.silentUpdate;
    delete payload.silentUpdate;

    return Vue.axios
      .post(Vue.$url("vessel-activity/clone"), payload)
      .then((rsp) => {
        if (!silentUpdate) {
          commit('mShowInfoMessage', 'Vessel Activities cloned', { root: true });
        }
        return rsp.data;
      })
  },

  async updateVesselActivity({ commit }, payload) {
    let silentUpdate = payload.silentUpdate;
    delete payload.silentUpdate;

    return Vue.axios.put(Vue.$url("vessel-activity/" + payload.id), payload)
      .then((rsp) => {
        if (!silentUpdate) {
          commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'Vessel Activity', 1: payload.id }), { root: true });
        }
        return rsp.data;
      })
  },

  async updateOldVesselActivity({ commit }, payload) {
    let silentUpdate = payload.silentUpdate;
    delete payload.silentUpdate;

    return Vue.axios.put(Vue.$url("vessel-activity/clone/" + payload.id), payload)
      .then((rsp) => {
        if (!silentUpdate) {
          commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'Vessel Activity', 1: payload.id }), { root: true });
        }
        return rsp.data;
      })
  },

  async deleteVesselActivity({ commit }, payload) {
    return Vue.axios
      .delete(Vue.$url("vessel-activity/" + payload.id))
      .then(() => {
        commit('mShowInfoMessage', i18n.t('common.deleted', { 0: 'Vessel Activity', 1: payload.id }), { root: true });
      });
  },

}